import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { IConsentimientosResponse } from '../../interfaces/response/IConsentimientosResponse';

const CONST_ID_OPERATIVA_NUEVA_PRODUCCION = 6;
const CONST_ID_OPERATIVA_COTIZACION = 3;


@Injectable({
  providedIn: 'root'
})
export class ConsentimientosService {

  baseUrl = `${environment.baseUrl}`;
  apiUrl = `${environment.ApiPolicy}`;
  url: string;

  constructor(private http: HttpClient) {
    this.url = this.baseUrl + this.apiUrl;
  }

  getConsentimientos(empresa: string, tipoDocumento: string, nroDocumento: string) {
    let params = new HttpParams({ fromObject: { empresa: empresa, tipoDocumento: tipoDocumento, nroDocumento: nroDocumento } });

    return this.http.get<any>(`${this.url}/GetConsentsbyPerson`, { params }).pipe(
      map(resp => resp.data)
    );
  }

  getConsentimientosLocal(idProducto: number, idPersona: number, proxy: boolean = false) {
    let url = `${this.url}/Consentimientos/locales/${idProducto}/${CONST_ID_OPERATIVA_NUEVA_PRODUCCION}?idPersona=${idPersona}`;

    if (proxy) {
      const apiUrl = `${environment.proxy.root}/${environment.proxy.api}/api-policy/api`     
      url = `${apiUrl}/Consentimientos/locales/${idProducto}/${CONST_ID_OPERATIVA_NUEVA_PRODUCCION}`;
    }

    return this.http.get<any>(url).pipe(
      map(resp => resp.data)
    );
  }

  getConsentimientosLocalAnonymous(idProducto?: number) {
    return this.http.get<IConsentimientosResponse>(`${this.url}/GetConsentsLocalbyProductAnonymous/${idProducto}/${CONST_ID_OPERATIVA_COTIZACION}`).pipe(
      map(resp => resp.data)
    );
  }

  setConsentimientos(body) {
    return this.http.post<any>(`${this.url}/SaveConsents`, body).pipe(
      map(resp => resp.data)
    );;
  }

  setConsentimientosLocal(body) {
    return this.http.post<any>(`${this.url}/SaveConsentsLocal`, body).pipe(
      map(resp => resp.data)
    );;
  }

  setConsentimientosLocalJob(body, proxy: boolean = false) {

    let url = `${this.url}/SaveConsentsLocalJob`;
    if(proxy) url = `${environment.proxy.root}/${environment.proxy.api}/${this.apiUrl}/Consentimientos/locales/job`;

    return this.http.post<any>(url, body).pipe(
      map(resp => resp.data)
    );;
  }

  setConsentimientosLocalAnonymous(body) {
    return this.http.post<any>(`${this.url}/SaveConsentsLocalAnonymous`, body).pipe(
      map(resp => resp.data)
    );
  }
}
